import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DeckGL from '@deck.gl/react';
import { Meteor } from 'meteor/meteor';
import { filter, map, isEqual, cloneDeep } from 'lodash';
import ButtonOnMap from '../ButtonOnMap';
import LayerControlOnMap from '../LayerControlOnMap';

const { defaultMapCenter } = Meteor.settings.public;
let addLayerToDeckViewer;
const FULFILLED_STATUS = 'fulfilled';

class DeckGLContainerViewMap extends Component {
  AllLayers = this.props.baseMaps.concat(this.props.layers);

  initialViewState = {
    longitude: (this.props.mapLocation.bbox[0] + this.props.mapLocation.bbox[2]) / 2,
    latitude: (this.props.mapLocation.bbox[1] + this.props.mapLocation.bbox[3]) / 2,
    zoom: this.props.mapLocation.properties.zoom - 1,
    pitch: 0,
    bearing: 0
  };

  state = {
    clientModulesReady: false,
    activeLayers: this.AllLayers.map(e => ({ id: e._id, visible: true })),
    allLayers: [],
    isMapViewerLoaded: false
  };

  componentDidMount() {
    const { clientModulesReady } = this.state;
    if (!clientModulesReady) this.loadClientModules();
  }

  componentDidUpdate = async (prevProps, prevState) => {
    const { activeLayers: prevActiveLayers } = prevState;
    const { clientModulesReady, isMapViewerLoaded, activeLayers } = this.state;
    if (clientModulesReady && !isMapViewerLoaded) this.initializeViewer();
    if (!isEqual(activeLayers, prevActiveLayers)) this.initializeViewer();
  };

  FindLayerVisible = ID => {
    const { activeLayers } = this.state;
    const result = activeLayers.find(({ id }) => id === ID);
    return cloneDeep(result.visible);
  };

  FindLayerVisible2 = ID => {
    const { activeLayers } = this.state;
    const result = activeLayers.find(({ id }) => id === ID);
    return result.visible;
  };

  ChageLayerVisible = ID => {
    const { activeLayers } = this.state;
    const newActiveLayers = activeLayers.map(e => {
      if (e.id === ID) {
        return { id: e.id, visible: !e.visible };
      }
      return e;
    });

    this.setState({ activeLayers: newActiveLayers });
  };

  initializeViewer = async () => {
    const { activeLayers } = this.state;
    const { baseMaps, layers } = this.props;
    const baseMapsPromises = baseMaps.map(layer => {
      const newLayer = addLayerToDeckViewer({
        layer,
        activeLayers,
        FindLayerVisible: this.FindLayerVisible
      });
      return newLayer;
    });

    const baseMapsArray = await Promise.allSettled(baseMapsPromises);

    const baseMapsResult = map(filter(baseMapsArray, { status: FULFILLED_STATUS }), 'value');

    const layersPromises = layers.map(layer => {
      const newLayer = addLayerToDeckViewer({
        layer,
        activeLayers,
        FindLayerVisible: this.FindLayerVisible
      });
      return newLayer;
    });

    const layersArray = await Promise.allSettled(layersPromises);

    const layersResult = map(filter(layersArray, { status: FULFILLED_STATUS }), 'value');

    this.setState({ allLayers: baseMapsResult.concat(layersResult), isMapViewerLoaded: true });
  };

  async loadClientModules() {
    if (Meteor.isClient) {
      ({ addLayerToDeckViewer } = await import('../../../modules/deck-operations'));
      this.setState({ clientModulesReady: true });
    }
  }

  render() {
    const { allLayers, activeLayers } = this.state;
    const { baseMaps, layers } = this.props;
    return (
      <>
        <DeckGL
          layers={allLayers}
          initialViewState={this.initialViewState}
          // getTooltip={getTooltip}
          controller
        />
        <ButtonOnMap numberOfButtonsRight={0}>
          <LayerControlOnMap
            baseMaps={baseMaps}
            layers={layers}
            activeLayers={activeLayers}
            FindLayerVisible={this.FindLayerVisible2}
            ChageLayerVisible={this.ChageLayerVisible}
          />
        </ButtonOnMap>
      </>
    );
  }
}
DeckGLContainerViewMap.defaultProps = {
  mapLocation: {
    longitude: defaultMapCenter.geometry.coordinates[0],
    latitude: defaultMapCenter.geometry.coordinates[1],
    zoom: defaultMapCenter.properties.zoom
  }
};

DeckGLContainerViewMap.propTypes = {
  baseMaps: PropTypes.array.isRequired,
  layers: PropTypes.array.isRequired,
  mapLocation: PropTypes.object
};
export default DeckGLContainerViewMap;
